
@for (lamelarea of lamellaAreas(); track lamelarea.id; let i = $index;) {
    <app-quantity-lamella-area
            [lamelareaId]="lamelarea.id"
            [lamellaArea]="lamelarea"
            [pageBreak]="(i+1)%3===0 && (i+1) !== lamellaAreaStore.getLamelareas().length"

    ></app-quantity-lamella-area>

}
